module.exports = __webpack_public_path__ + "img/price-quote-title.0e9fbf6a.svg";